export default {"src":"/_next/static/media/lower-wave.715d393f.svg","height":117,"width":1440,"blurWidth":0,"blurHeight":0};